<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data.nzTitle}}</p>
    </div>
    <div class="flex justify-end">
        <nz-input-group class="w-[200px]" [nzPrefix]="searchIconProductionOrderProcesses"
            [nzSuffix]="clearInputProductionOrderProcesses">
            <input onfocus="select()" placeholder="Nº orden / Descripción orden" nz-input
                [(ngModel)]="searchProductionOrderProcesses" (ngModelChange)="onSearch($event)" />
        </nz-input-group>
        <ng-template #clearInputProductionOrderProcesses>
            @if (searchProductionOrderProcesses) {
            <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="clearFilter()"
                nz-icon></span>
            }
        </ng-template>
        <ng-template #searchIconProductionOrderProcesses>
            <span nz-icon nzType="search"></span>
        </ng-template>
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @if (productionOrderProcesses && productionOrderProcesses.length > 0) {
        <nz-table #productionProcessessTable [nzData]="productionOrderProcesses" class="m-0 p-0" nzSize="small"
            [nzLoading]="isLoading" nzTableLayout="auto" [nzBordered]="true" [nzFrontPagination]="false"
            [nzShowPagination]="false" [nzScroll]="{ y: (tableHeight || 0) + 'px', x:'240px' }">
            <thead>
                <tr>
                    <th nzWidth="150px">Núm</th>
                    <th nzWidth="130px">Proceso</th>
                    <th nzWidth="130px">Orden prioridad</th>
                    @if (showWithProductionOrdersPermissions('priorityNameColumn')) {
                        <th nzWidth="130px">Prioridad</th>
                    }
                    <th nzWidth="150px">Descripción</th>
                    <th nzWidth="125px">Fecha inicio</th>
                    <th nzWidth="150px">Cliente</th>
                    @if (showWithProductionOrdersPermissions('productionRouteColumn')) {
                        <th nzWidth="150px">Ruta</th>
                    }
                    <th nzWidth="120px">Estado</th>
                    <th nzWidth="100px">Progreso</th>
                    <th nzRight nzWidth="100px">Acciones</th>
                </tr>
            </thead>
            <tbody>
                @for (process of productionProcessessTable.data; track process) {
                <tr>
                    <td>
                        @if (idColumnValueToShow == 'id') {
                            {{ process.productionOrder!.id }}
                        }
                        @else if (idColumnValueToShow == 'externalId') {
                            {{ process.productionOrder!.externalId }}
                        }
                        @else if (idColumnValueToShow == 'finalProduct') {
                            {{ getIdColumnValue(process) }}
                        }
                        @else {
                            -
                        }
                    </td>

                    <td>
                        {{ process.productionProcess.name }}
                    </td>

                    <td>
                        <div class="flex items-center justify-center">
                            <span>
                                {{ process.productionOrder!.priorityOrder }}
                            </span>
                        </div>
                    </td>

                    @if (showWithProductionOrdersPermissions('priorityNameColumn')) {
                        <td>
                            <div class="flex items-center justify-center">
                                <span [class]="process.productionOrder!.priority?.cssClassName">
                                    {{ process.productionOrder!.priority?.name }}
                                </span>
                            </div>
                        </td>
                    }

                    <td>
                        {{ process.productionOrder!.description }}
                    </td>
                    <td class="text-center">
                        {{ process.productionOrder!.startDate | date: "dd/MM/YYYY" }}
                    </td>

                    <td class="text-sky-500 font-medium" style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            ">
                        {{ process.productionOrder!.customers?.name }}
                    </td>

                    @if (showWithProductionOrdersPermissions('productionRouteColumn')) {
                        <td>
                            {{ process.productionOrder!.productionRoute ? process.productionOrder!.productionRoute.name : "-" }}
                        </td>
                    }

                    <td class="text-center align-middle">
                        <span [ngClass]="process.productionOrder!.status?.cssClassName">
                            {{ process.productionOrder!.status?.name }}
                        </span>
                    </td>

                    <td style="width: 140px !important;text-overflow: ellipsis;">
                        <nz-progress [nzPercent]="calculateProductionProcessProgress(process)" nzSize="small"></nz-progress>
                    </td>

                    <td nzRight>
                        <div class="flex align-middle justify-center">
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Ver proceso'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="navigateToProductionOrder(process.productionOrder!.id, process.id!)">
                                <span nz-icon nzType="fund-view"></span>
                            </button>
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </nz-table>
        }
        @else {
        <div class="w-full h-full content-center">
            <nz-empty></nz-empty>
        </div>
        }
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button">
            Cerrar
        </button>
    </div>
</div>
